import { render, staticRenderFns } from "./cardTemplateVip02.vue?vue&type=template&id=79fea3d4&scoped=true&"
import script from "./cardTemplateVip02.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip02.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip02.vue?vue&type=style&index=0&id=79fea3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fea3d4",
  null
  
)

export default component.exports